module.exports = "<div class=\"container\">\n    <!--<app-modal \n        [modal]=\"modal\"\n      ></app-modal>-->\n    <app-header></app-header>\n    <app-progress-bar></app-progress-bar>\n    <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main